import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {handleApiError} from 'common/src/modules/errorHandling/handleApiError';
import dashboardsApi from '../../dashboards.api';
import {updateDashboards} from '../dashboardPage.slice';

export const refreshAccountDashboards = createAsyncThunk<void>(
  `${BreadcrumbName.Dashboard}/refreshDashboards`,
  async (_, {dispatch}) => {
    try {
      const dashboards = await dashboardsApi.getDashboards();

      dispatch(updateDashboards(dashboards));
    } catch (error) {
      handleApiError(error);
    }
  },
);
